'use client'

import AllServicesHeroSection from '@/components/services/allServicesHeroSection'
import AllServicesSubSection from '@/components/services/allServicesSubSection'
import HowItWorks from '@/components/services/online-psychiatry/howItWorks'
import OnlinePsychiatryBenefits from '@/components/services/online-psychiatry/benefits'
import IsItRightForYou from '@/components/services/online-psychiatry/right'
import OnlinePsychiatryCTA from '@/components/services/online-psychiatry/cta'
import CrisisGuidance from '@/components/CrisisGuidance'
import { BookOpenCheck } from 'lucide-react'

const OnlinePsychiatryPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* Hero */}
      <AllServicesHeroSection
        title="Convenient Online Psychiatry: Expert Mental Health Care, Wherever You Are"
        description="Access our full range of psychiatric services, including evaluations, therapy, and medication management, from the privacy and comfort of your home via secure video conferencing."
      />

      {/* What is Online Psychiatry */}
      <AllServicesSubSection
        title="What is Online Psychiatry (Telehealth) at ReACH?"
        para1="Online psychiatry, also known as telehealth or telepsychiatry, allows you to connect with our expert psychiatrists and therapists through secure video conferencing technology. At ReACH Psychiatry, you can receive comprehensive mental health care - including initial evaluations, ongoing therapy sessions, and medication management - without needing to travel to our clinic."
        para2="It's designed to be convenient, confidential, and just as effective as in-person care for many individuals. Our online services maintain the same high standards of care and personalized approach that define all our services at ReACH Psychiatry."
        icon={BookOpenCheck}
      />

      {/* How it Works */}
      <HowItWorks />

      {/* Benefits */}
      <OnlinePsychiatryBenefits />

      {/* Is it Right for You */}
      <IsItRightForYou />

      {/* Urgent-help guidance (P2.13, approved wording): completes the
          severe-crisis caveat above with an actual next step, kept separate
          from the routine booking CTA below. */}
      <CrisisGuidance variant="card" />

      {/* CTA */}
      <OnlinePsychiatryCTA />
    </div>
  )
}

export default OnlinePsychiatryPage
